import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface VersionInfo {
  name: string;
  version: string;
  buildId: string;
}

export interface AppVersions {
  ui: VersionInfo;
  api: VersionInfo;
}

@Injectable({ providedIn: 'root' })
export class VersionService {
  private apiUrl = `${window.location.origin}/api`;

  constructor(private http: HttpClient) {}

  getUIVersion(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>('/version.json').pipe(
      catchError((error) => {
        console.warn('Could not load UI version', error);
        return of({
          name: 'Envolve UI',
          version: 'unknown',
          buildId: 'unknown',
        });
      })
    );
  }

  getAPIVersion(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>(`${this.apiUrl}/version`).pipe(
      catchError((error) => {
        console.warn('Could not load API version', error);
        return of({
          name: 'Envolve API',
          version: 'unknown',
          buildId: 'unknown',
        });
      })
    );
  }

  getAllVersions(): Observable<AppVersions> {
    return forkJoin({
      ui: this.getUIVersion(),
      api: this.getAPIVersion(),
    });
  }

  /**
   * Get just the UI version number for display in footer
   */
  getUIVersionNumber(): Observable<string> {
    return this.getUIVersion().pipe(
      map(v => v.version)
    );
  }
}
